import React, { memo } from 'react';
export const FromTheAuthorsSection = () => {
  return <section className="py-8 md:py-12 bg-gradient-to-b from-bttf-bg via-bttf-bg/95 to-bttf-bg relative overflow-hidden" data-id="element-108">
      <div className="absolute inset-0 bg-bttf-highlight/5 mix-blend-overlay" data-id="element-109"></div>
      <div className="absolute -top-40 -left-40 w-80 h-80 bg-bttf-primary/10 rounded-full blur-3xl" data-id="element-110"></div>
      <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-bttf-accent/10 rounded-full blur-3xl" data-id="element-111"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-112">
        <div className="text-center mb-8" data-id="element-113">
          <div className="flex justify-center mb-3" data-id="element-114">
            <StarIcon className="h-8 w-8 text-bttf-primary fill-current shadow-neon-orange" data-id="element-115" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-future tracking-wide bg-gradient-main text-transparent bg-clip-text mb-2" data-id="element-116">
            FROM THE AUTHORS
          </h2>
          <div className="w-20 h-1 bg-bttf-primary mx-auto" data-id="element-117"></div>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-118">
          <div className="bg-bttf-bg/80 border-2 border-bttf-accent/30 rounded-xl p-6 md:p-10 backdrop-blur-sm shadow-[0_0_20px_rgba(0,195,255,0.2)]" data-id="element-119">
            <p className="text-xl md:text-2xl text-bttf-text leading-relaxed mb-6 font-semibold" data-id="element-120">
              For forty years, you've been searching for this book.
            </p>

            <p className="text-lg text-bttf-subtext leading-relaxed mb-6" data-id="element-121">
              You didn't know you were searching for it. But every time you
              finished watching <em data-id="element-122">Back to the Future</em> for the hundredth
              time, every time you fell down a Reddit thread about the clock
              tower sequence, every time you wished someone would explain why
              this film hits differently than every other time travel movie—
              <strong data-id="element-123">you were searching</strong>.
            </p>

            <p className="text-xl md:text-2xl text-bttf-accent leading-relaxed mb-6 font-bold" data-id="element-124">
              This is that book.
            </p>

            <p className="text-lg text-bttf-subtext leading-relaxed mb-6" data-id="element-125">
              Not the coffee table book with photos you've seen a thousand
              times. Not the "remember the 80s?" nostalgia trip. Not the
              surface-level "making of" that tells you Michael J. Fox was tired.
            </p>

            <p className="text-lg text-bttf-text leading-relaxed mb-6" data-id="element-126">
              <strong className="text-bttf-accent" data-id="element-127">
                BACK IN TIME: 40th Anniversary Edition
              </strong>{' '}
              is the comprehensive deep-dive you've been waiting for—exploring
              the cultural phenomenon, the emotional legacy, and why this film
              embedded itself in our collective consciousness like no other time
              travel story before or since.
            </p>

            <p className="text-xl md:text-2xl text-bttf-text leading-relaxed mb-6 font-semibold" data-id="element-128">
              But we didn't stop there.
            </p>

            <p className="text-xl md:text-2xl text-bttf-primary leading-relaxed mb-6 font-bold" data-id="element-129">
              Because one book wasn't enough.
            </p>

            <p className="text-lg text-bttf-subtext leading-relaxed mb-8" data-id="element-130">
              The fans who memorize every frame don't just want cultural
              analysis. They want the production stories—the 3 AM DeLorean
              breakdowns, the safety harness failures, the crew superstitions.
              They want the voices—cast, crew, critics, fans—reflecting on forty
              years. They want the philosophy—the deep examination of free will,
              identity, and what Doc Brown's time machine reveals about who we
              are.
            </p>

            <p className="text-xl text-bttf-text leading-relaxed mb-6 font-semibold" data-id="element-131">
              So we created three additional volumes:
            </p>

            <div className="space-y-6 mb-8 pl-4 border-l-4 border-bttf-primary/50" data-id="element-132">
              <div data-id="element-133">
                <h3 className="text-xl font-bold text-bttf-accent mb-2 font-future" data-id="element-134">
                  BEHIND THE CLOCK TOWER: Stories from the Set
                </h3>
                <p className="text-base text-bttf-subtext leading-relaxed" data-id="element-135">
                  The production deep-dive. What happened when the cameras
                  weren't rolling. The technical nightmares that became
                  cinematic magic.
                </p>
              </div>

              <div data-id="element-136">
                <h3 className="text-xl font-bold text-bttf-accent mb-2 font-future" data-id="element-137">
                  GREAT SCOTT! 40 Quotes for 40 Years
                </h3>
                <p className="text-base text-bttf-subtext leading-relaxed" data-id="element-138">
                  Forty voices across four decades. From Bob Gale to anonymous
                  fans whose lives this film changed. Each quote paired with
                  reflection on why it matters.
                </p>
              </div>

              <div data-id="element-139">
                <h3 className="text-xl font-bold text-bttf-accent mb-2 font-future" data-id="element-140">
                  TIME, IMAGINATION & DESTINY
                </h3>
                <p className="text-base text-bttf-subtext leading-relaxed" data-id="element-141">
                  The philosophical companion. Free will. Identity. Causation.
                  Why we cry when George punches Biff. What this film says about
                  being human.
                </p>
              </div>
            </div>

            <p className="text-lg text-bttf-text leading-relaxed mb-6" data-id="element-142">
              <strong data-id="element-143">
                Nobody wrote this before because nobody cared enough to spend
                two years doing it right.
              </strong>
            </p>

            <p className="text-lg text-bttf-text leading-relaxed mb-6" data-id="element-144">
              We did. We're{' '}
              <strong className="text-bttf-primary" data-id="element-145">The VHS Club</strong>—a team
              of writers and researchers who refused to let the 40th anniversary
              pass with just another "commemorative edition" of recycled
              content. Published by{' '}
              <strong className="text-bttf-primary" data-id="element-146">Legendary Reads</strong>,
              we're independent and unapologetic about creating
              the collection that mainstream publishers wouldn't touch.
            </p>

            <p className="text-xl md:text-2xl text-bttf-accent leading-relaxed mb-6 font-bold" data-id="element-147">
              This is the collection you've been waiting for.
            </p>

            <p className="text-lg text-bttf-subtext leading-relaxed mb-6" data-id="element-148">
              One comprehensive book. Three deep-dive supplements.{' '}
              <strong data-id="element-149">50,000+ words total</strong>. Every detail verified. Every
              source cited. Every page written for fans who want depth, not
              decoration.
            </p>

            <p className="text-2xl md:text-3xl text-bttf-primary leading-relaxed font-bold text-center mt-8" data-id="element-150">
              It's here. Finally.
            </p>

            <p className="text-sm text-bttf-subtext text-center mt-6 italic" data-id="element-151">
              Published by Legendary Reads • Written by The VHS Club
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const StarIcon = ({
  className
}: {
  className: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-152">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-153"></polygon>
  </svg>;